import React from 'react';
import { Text } from 'react-native';

const NumberFormat = ({ number, locale = 'en-US', style = {}, options = {} }) => {
    // فرمت کردن عدد با استفاده از Intl.NumberFormat
    const formattedNumber = new Intl.NumberFormat(locale, options).format(number);

    return <Text style={style}>{formattedNumber}</Text>;
};

export default NumberFormat;
